import invariant from 'invariant';
import React, { useContext } from 'react';

import type { Header } from '@swf/core/enums';
import { ResponseHeadersContext } from '@swf/core/providers/ResponseHeadersProvider';
import { canUseDOM } from '@swf/core/utils';
import { compareCacheControl } from '@swf/core/utils/compareCacheControl';

export const ResponseHeaders: React.FC<{ children: string }> = ({ children }) => {
  const headers = useContext(ResponseHeadersContext);
  if (!canUseDOM) {
    children
      .trim()
      .split('\n')
      .map((item) => item.trim().split(':'))
      .forEach(([key, value]) => {
        invariant(key && value, 'ResponseHeaders must be well-formed HTTP headers');
        headers.setHeader(key, value.trim());
      });
  }
  return null;
};

export const CacheControl: React.FC<{ children: string }> = ({ children }) => (
  <ResponseHeaders>{`cache-control:${compareCacheControl(
    children,
    useContext(ResponseHeadersContext).headers['cache-control']
  )}`}</ResponseHeaders>
);

export const Vary: React.FC<{ by: Header[]; children?: undefined; force?: boolean }> = ({
  by,
  force
}) => {
  useVary({ by, force });
  return null;
};

export const useVary = ({ by, force }: { by: Header[]; force?: boolean }) => {
  const headers = useContext(ResponseHeadersContext);
  if (!canUseDOM) {
    if (force) {
      headers.setVaryHeaders(by);
    } else {
      headers.addVaryHeaders(by);
    }
  }
};

export default ResponseHeaders;
